import api from '@/services/api'

export const getGoalsFromAPI = async (indicatorId, searchTerm, periods) => {
    try {
        const params = getParams(indicatorId, searchTerm, periods)

        return await api.get('goals/list-to-formula', { params })
    } catch (e) {
        console.log(e)
    }
}

export const getIndicatorsFromAPI = async (
    indicatorId,
    searchTerm,
    periods
) => {
    try {
        const params = getParams(indicatorId, searchTerm, periods)

        return await api.get('indicators/list-to-formula', { params })
    } catch (e) {
        console.log(e)
    }
}

const getParams = (indicatorId, title, periods) => {
    const params = {
        search: `id:${indicatorId}`,
        searchFields: 'id:!=',
        and: 'yes',
        orderBy: 'title',
        sortedBy: 'asc',
        per_page: 8,
        periods: periods,
    }

    if (title) {
        params.search += `;title:${title};`
        params.searchFields += ';title:like'
    }

    return params
}
